<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Administradores</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Condición ..."
                        class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                  <b-button variant="primary" class="ml-5" v-on:click="agregarUsuario" v-if="permiteAgregar">Agregar</b-button>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  :items="usuarios"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
                  :bordered="true" :hover="true"
              >
                <template #cell(nombres)="data">
                  {{ data.item.primernombre }} {{ data.item.segundonombre }}
                </template>
                <template #cell(active)="data">
                  <div style="text-align: center">
                    <i class="bx bx-check-circle" style="color: darkgreen" v-if="data.item.active == 1"></i>
                    <i class="bx bx-x-circle" style="color: red" v-if="data.item.active == 0"></i>
                  </div>
                </template>
                <template #cell(edicion)="data">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Acciones">
                    <button type="button" class="btn btn-success" v-on:click="edicionUsuario(data.item.id)">Editar</button>
<!--                    <button type="button" class="btn btn-info" v-on:click="cambiarPassword(data.item.id)"><i class="bx bx-key"></i></button>-->
                    <button type="button" class="btn btn-danger"
                            v-on:click="eliminacionUsuario(data.item)"
                            v-if="data.item.id != yo && data.item.rol > 1">Eliminar</button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div v-if="editarUsuario">
      <b-modal id="modalUsuario" size="lg" :hide-footer="true" v-model="editarUsuario" title='Identificación del Usuario'>
        <edicion-usuario :id="idUsuario" :disponibilidad="disponibilidad" @updateUsuarios="cerrarUsuario"></edicion-usuario>
      </b-modal>
    </div>

    <div v-if="editarPassword">
      <b-modal id="modalUsuario" :hide-footer="true" v-model="editarPassword" title='Cambio de contraseña'>
        <edicion-password :id="idUsuario" @updateUsuarioPassword="cerrarPassword"></edicion-password>
      </b-modal>
    </div>

  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { usuariosService } from "@/helpers/servicios/configuracion/usuarios.service";
import {operacionesService} from "@/helpers/servicios/operaciones/operaciones";
import EdicionUsuario from "@/components/configuracion/edicionUsuario";
import {generalService} from "@/helpers/servicios/configuracion/genera.service";
import EdicionPassword from "@/components/configuracion/edicionPassword";

export default {
  name: "usuarios",
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    EdicionPassword,
    EdicionUsuario,
    Layout,
    PageHeader,
  },
  computed: {
    rows()  {
      return this.usuarios.length;
    }
  },
  data() {
    return {
      title: "Gestión de Usuarios",
      items: [
        {
          text: "Principal",
          href: "/",
        },
        {
          text: "Configuración"
        },
        {
          text: "Usuarios",
          active: true,
        },
      ],
      usuarios: [], idUsuario: null,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      fields: [
        { key: "name", label: "Nombre", sortable: true},
        { key: "email", label: "Email", sortable: true },
        { key: "sucursal", label: "Sucursal", sortable: true},
        { key: "rol_descripcion", label: "Rol", sortable: true},
        { key: "active", label: "Act.", sortable: true },
        { key: "edicion", label: "Acción", sortable: false}
      ],
      sortBy: "name", sortDesc: true,
      editarUsuario: false, editarPassword: false,
      yo: null, sucursales: [], disponibilidad: [],
      permiteAgregar: false
    };
  },
  mounted() {
    this.obtenerDatos()
    this.listarUsuarios();
    this.thisUser();
  },
  methods: {
    async listarUsuarios()  {
      usuariosService.listarUsuarios().then((response) => {
        this.usuarios = response;
        this._reglasNegocio()
      }).catch((error) => {
        if (error.expired)  this.$router.push("/login");
        this.usuarios = [];
      })
    },
    async obtenerDatos()  {
      operacionesService.obtenerEstacionamiento().then((response) => {
        if (response.resultado === "ok")  {
          this.sucursales = response.sucursales
        }
      })
    },
    _reglasNegocio() {
      let cuantosSucursal = 0
      let cuantosUsuarios = 0
      this.disponibilidad = []
      this.sucursales.forEach(element => {
        this.disponibilidad.push(
          {
            idsucursal: element.idsucursal,
            identificacion: element.identificacion,
            cupos: element.cupos,
            utilizados: 0,
            administrador: false
          }
        )
        cuantosSucursal += element.cupos
      });
      this.usuarios.forEach(element => {
        if (element.rol > 2)  {
          this.disponibilidad = this.disponibilidad.map(function(obj) {
            if (obj.idsucursal === element.idsucursal)  obj.utilizados++
            return obj
          })
          cuantosUsuarios++
        }
        if (element.rol == 2)  {
          this.disponibilidad = this.disponibilidad.map(function(obj) {
            if (obj.idsucursal === element.idsucursal)  obj.administrador = true
            return obj
          })
        }
      })
      this.permiteAgregar = (cuantosSucursal > cuantosUsuarios)
    },

    async thisUser()  {
      generalService.thisUser().then((response) => {
        this.yo = response.id;
      })
    },
    agregarUsuario()  {
      this.edicionUsuario(null);
    },
    edicionUsuario(id)  {
      this.idUsuario = id;
      this.editarUsuario = true;
    },
    cambiarPassword(id) {
      this.idUsuario = id;
      this.editarPassword = true;
    },
    eliminacionUsuario(item)  {
      this.idUsuario = item.id;
      this.$bvModal.msgBoxConfirm("Está seguro/a de eliminar a " + item.name, {
        title: "Eliminar Usuario",
        okVariant: "danger",
        okTitle: "Eliminar",
        cancelTitle: "Cancelar"
      }).then(value => {
        if (value)  {
          this.eliminarUsuario(this.idUsuario);
        }
      }).catch(err => {
        window.console.log(err);
      })
    },
    eliminarUsuario(id) {
      usuariosService.eliminarUsuario(id).then((response) => {
        if (response.resultado == "ok") {
          this._toast_done("El usuario ha sido eliminado")
          this.listarUsuarios()
        } else {
          this._error(response.mensaje);
        }
      }).catch((error) => {
        if (error.status == 422)  {
          this._error("Datos incompletos o con errores, por favor revíselos");
        } else {
          this._error(error.mensaje);
        }
      })
    },
    cerrarUsuario() {
      this.editarUsuario = false;
      this._toast_done("El usuario ha sido guardado")
      this.listarUsuarios();
    },
    cerrarPassword()  {
      this.editarPassword = false;
      this._toast_done("La contraseña ha sido cambiada")
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    _error(mensaje) {
      this.$bvToast.toast(mensaje, {
        title: "Error",
        autoHideDelay: 5000,
        appendToast: false,
        variant: "danger",
        solid: true,
        toaster: "b-toaster-bottom-right"
      })
    },
    _toast_done(mensaje) {
      this.$bvToast.toast(mensaje, {
        title: "Hecho !",
        autoHideDelay: 5000,
        appendToast: false,
        variant: "success",
        solid: true,
        toaster: "b-toaster-bottom-right"
      });
    }
  }

}
</script>

<style scoped>

</style>
